import { ShowButton as ReactAdminShowButton, ShowButtonProps } from 'react-admin'

export const ShowButton = (props: ShowButtonProps): JSX.Element => {
  return <ReactAdminShowButton {...props} size='medium' />
}
